import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(2),
  overflow: 'hidden',
};

export const header: SxStyle = {
  backgroundColor: (p) => p.palette.grey[200],
  //   borderRadius: (p) => p.spacing(1.5, 1.5, 0, 0),
  padding: (p) => p.spacing(1.25, 2),
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  color: (p) => p.palette.grey[600],
};

export const description: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  color: (p) => p.palette.grey[600],
};

export const tooltipIcon: SxStyle = {
  color: (p) => p.palette.grey[600],
};
